<template>
  <div>
    <vm-table
        ref="vmTable"
        height="70Vh"
        :filter.sync="filter"
        module="basic"
        url="scanRecords/getByBoard"
        @select="select"
        @select-all="select">
      <div slot="toolbar">
        <el-button type="success" @click="printMultiple">批量打印</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="出厂编号">
            <el-input
                v-model.trim="filter.factoryNo"
                type="textarea"
                :autosize="{ minRows:1, maxRows:6 }"
                style="width: 150px"
                clearable/>
          </vm-search>
          <vm-search label="类型">
            <el-select v-model="filter.bordType" clearable placeholder="请选择">
              <el-option label="主板（IO-B）" :value="0"/>
              <el-option label="一体机" :value="1"/>
            </el-select>
          </vm-search>
          <vm-search label="条码">
            <el-input v-model="filter.barcode"/>
          </vm-search>
          <vm-search label="物料描述">
            <el-input v-model="filter.procurementInspection"/>
          </vm-search>
          <vm-search label="扫描时间:">
            <div>
              <el-date-picker
                  v-model="filter.beginCreateTime"
                  value-format="yyyy-MM-dd 00:00:00"
                  type="date"
                  style="width: 190px"
                  placeholder="请选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至:">
            <div>
              <el-date-picker
                  v-model="filter.endCreateTime"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 190px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="cableCode" label="出厂编号" align="center" width="120"/>
      <el-table-column prop="cabinetCode" label="" width="180" align="center"/>
      <el-table-column prop="repairOrder" label="工单号" align="center"/>
      <el-table-column prop="partsbarCode" label="条码" width="220" align="center"/>
      <el-table-column prop="location" label="客户名称" align="center" width="220"/>
      <el-table-column prop="procurement" label="" align="center"/>
      <el-table-column prop="partNo" label="物料号" align="center"/>
      <el-table-column prop="procurementInspection" label="物料描述" align="center" width="180"/>
      <el-table-column prop="scanDate" label="扫描时间" width="220" align="center"/>
      <el-table-column prop="scanMenName" label="扫描人" width="220" align="center"/>
      <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="120px">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editPage.open(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <k-z-g-report-edit ref="editPage"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable";
  import VmSearch from "@/components/VmSearch";
  import KZGReportEdit from "@/views/purchase/kzgReport/KZGReportEdit";

  export default {
    name: "KZGReportList",
    components: {KZGReportEdit, VmTable, VmSearch},
    data() {
      return {
        filter: {
          factoryNo: "",
          barcode: "",
          bordType: 0,
          procurementInspection: "",
          beginCreateTime: "",
          endCreateTime: "",
        },
        idList: [],
        tableData: {},
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      select(selection) {
        this.idList = [];
        selection.forEach(item => {
          this.idList.push(item.pkid);
        });
      },
      printMultiple() {
        if (!this.idList || this.idList.length === 0) {
          return this.$message.error("请至少选择一项");
        }
        let routeData = this.$router.resolve({
          path: "/kzgInspectionMultiPrintPage",
          query: {
            items: JSON.stringify(this.idList),
          },
        });
        window.open(routeData.href, "__blank");
      },
    },
  };

</script>

<style>

</style>